import { useState } from "react";
import CreateDraftModal from "./createDraftModal";
import { useWatches } from "../../../../../context/watchProvider";
import { useAuth } from "../../../../../context/authProvider";
import EditDraftModal from "./editDraftModal";
import AdminModal from "../../../../core/admin/adminModal";
import AdminCard from "../../../../core/admin/adminCard";
import AdminTable from "../../../../core/admin/adminTable";
import AdminButton from "../../../../core/admin/adminButton";
import AdminCallout from "../../../../core/admin/adminCallout";
import AdminEmptyState from "../../../../core/admin/adminEmptyState";
import AdminBadge, { AdminCount } from "../../../../core/admin/adminBadge";
import { PencilIcon, PlusLineIcon, TrashIcon } from "../../../../../img/svg/adminIcons";
import { IWatch } from "../../watches/adminWatches";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../../../../utils/functions";

export default function DraftWatches({ watches, finish, editOk, deleteOk, refresh }: { watches: IWatch[], finish: () => void, editOk: () => void, deleteOk: () => void, refresh: () => void }) {

    const { userId, user } = useAuth();
    const { deleteWatch } = useWatches();
    const navigate = useNavigate();

    const [createModal, setCreateModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [phoneModal, setPhoneModal] = useState(false);
    const [editableWatch, setEditableWatch] = useState<IWatch | null>(null);

    const [deleteLoading, setDeleteLoading] = useState(false);
    //() => deleteWatch(userId, w.id)
    const handleEditModal = (watch: IWatch) => {
        setEditableWatch(watch);
        setEditModal(true);
    }

    const handleDeleteModal = (watch: IWatch) => {
        setEditableWatch(watch);
        setDeleteModal(true);
    }

    const handleDeleteWatch = async (watchId: string | undefined) => {
        setDeleteLoading(true);
        if (!watchId) {
            setDeleteLoading(false);
            return null;
        }
        const deleteResponse = await deleteWatch(userId, watchId);
        if (!deleteResponse) {
            setDeleteLoading(false);
            return null;
        }
        setDeleteLoading(false);
        setDeleteModal(false);
        deleteOk();
    }

    const handleCreateModal = () => {
        if (!user || !user.phoneNumber || user.phoneNumber.length < 10) {
            setPhoneModal(true);
            return null;
        }
        setCreateModal(true);
    }

    return (
        <AdminCard
            title={<>Rascunhos <AdminCount count={watches.length} /></>}
            description="Complete as informações e as imagens e envie para aprovação."
            actions={<AdminButton icon={<PlusLineIcon width="16px" />} onClick={handleCreateModal}>Criar rascunho</AdminButton>}
            bodyClassName="p-3 md:p-4"
        >
            {
                watches.length ?
                    <AdminTable
                        rows={watches}
                        rowKey={(w, idx) => w.id || idx}
                        columns={[
                            { header: "Relógio", mobile: "title", desktopHidden: true, render: w => `${w.brand || ""} ${w.model || ""}` },
                            { header: "Marca", mobile: "hidden", render: w => <span className="font-semibold">{w.brand}</span> },
                            { header: "Modelo", mobile: "hidden", render: w => w.model },
                            { header: "Ano", render: w => w.year },
                            { header: "Situação", render: w => w.comment ? <AdminBadge tone="warning" dot>Comentário do admin</AdminBadge> : <span className="text-gray-400">—</span> },
                        ]}
                        actions={w => (
                            <>
                                <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => handleEditModal(w)}>Completar</AdminButton>
                                <AdminButton size="sm" variant="ghost" className="!text-red-600 hover:!bg-red-50" title="Excluir rascunho" icon={<TrashIcon width="16px" />} onClick={() => handleDeleteModal(w)}>Excluir</AdminButton>
                            </>
                        )}
                    />
                    :
                    <AdminEmptyState title="Nenhum relógio listado" description="Clique em “Criar rascunho” para cadastrar um relógio." />
            }
            {
                createModal ?
                    <CreateDraftModal close={() => setCreateModal(false)} finish={finish}
                    />
                    : null
            }
            {
                editModal ?
                    <EditDraftModal close={() => setEditModal(false)} watch={editableWatch} setWatch={setEditableWatch} finish={editOk} refresh={refresh} />
                    : null
            }
            {
                deleteModal ?
                    <AdminModal
                        close={() => setDeleteModal(false)}
                        size="sm"
                        title="Tem certeza que deseja excluir este rascunho de relógio?"
                        subtitle={`${editableWatch?.brand || ""} ${editableWatch?.model || ""}`}
                        footer={
                            <>
                                <AdminButton variant="secondary" disabled={deleteLoading} onClick={() => setDeleteModal(false)}>Cancelar</AdminButton>
                                <AdminButton variant="danger" loading={deleteLoading} onClick={() => handleDeleteWatch(editableWatch?.id)}>Sim, excluir</AdminButton>
                            </>
                        }
                    >
                        <p className="text-sm text-gray-600">O rascunho e as imagens enviadas serão removidos e não poderão ser recuperados.</p>
                    </AdminModal>
                    : null
            }
            {
                phoneModal ?
                    <AdminModal
                        close={() => setPhoneModal(false)}
                        size="sm"
                        title="Para anunciar uma peça, é preciso cadastrar um número de telefone válido!"
                        footer={
                            <>
                                <AdminButton variant="secondary" onClick={() => setPhoneModal(false)}>Cancelar</AdminButton>
                                <AdminButton onClick={() => navigate("/me")}>Cadastrar telefone</AdminButton>
                            </>
                        }
                    >
                        {
                            user?.phoneNumber && user?.phoneNumber.length < 10?
                            <AdminCallout tone="warning">O número {formatPhoneNumber(user.phoneNumber)} é muito curto. Certifique-se de que informou o DDD corretamente.</AdminCallout>
                            : <p className="text-sm text-gray-600">Cadastre seu telefone na Minha Área e volte para criar o rascunho.</p>
                        }
                    </AdminModal>
                    : null
            }
        </AdminCard>
    )
}